module.exports = __webpack_public_path__ + "img/bril0.ceca44d5.png";